import { render, staticRenderFns } from "./salonList.vue?vue&type=template&id=16afe588&scoped=true&"
import script from "./salonList.vue?vue&type=script&lang=js&"
export * from "./salonList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16afe588",
  null
  
)

export default component.exports